<app-header></app-header>
<section class="Headline">
  <section class="pt-5">
    <div>
      <h1 class="text-center main-color edit-words">
       {{'how-students-learn'|translate}} <br />
        {{'ROBOGARDEN-PLAYGROUND'|translate}}
      </h1>
    </div>
    <div class="d-flex justify-content-evenly mt-5 edit-design">
      <div class="d-flex me-5">
        <img class="edit-correct" src="assets_main/images/greencorrect.png" alt="" />
        <h3 class="edit-ph">
          {{'offer'|translate}}<br />
          {{'journey-school'|translate}}
        </h3>
      </div>
      <div class="d-flex me-1 edit-query">
        <img class="edit-correct" src="assets_main/images/bluecorrect.png" alt="" />
        <h3 class="edit-ph">
         {{'js-everyone'|translate}} <br />
          {{'pythone-professional'|translate}}
        </h3>
      </div>
    </div>
    <div class="d-flex justify-content-evenly mt-2 edit-design">
      <div class="d-flex me-1 edit-res">
        <img class="edit-correct" src="assets_main/images/bluecorrect.png" alt="" />
        <h3 class="edit-ph">
          {{'students-start'|translate}} <br />
          {{'beginner-level'|translate}}
        </h3>
      </div>
      <div class="d-flex me-5">
        <img class="edit-correct" src="assets_main/images/greencorrect.png" alt="" />
        <h3 class="edit-ph">
          {{'all-journey'|translate}}<br />
          {{'ENVIRONMENT'|translate}}.
        </h3>
      </div>
    </div>
  </section>
  <section class="edit-section">
    <div>
      <h1 class="text-center text-edit main-color">
        {{'click-each'|translate}}<br />
        {{'learning-objec'|translate}}
      </h1>
    </div>
  </section>
  <section class="">
    <div class="course photo">
      <img class="course-div" src="assets_main/images/mapjourney.png" alt="" />
      <img
        class="course-img"
        (click)="open(content, courses[0]?.id, '1')"
        [src]="courses[0]?.CardIconURL"
      />

      <img
        class="course-img2"
        (click)="open(content, courses[16]?.id, '2')"
        [src]="courses[16]?.CardIconURL"
      />
      <img
        class="course-img3"
        (click)="open(content, courses[4]?.id, '3')"
        [src]="courses[4]?.CardIconURL"
      />
      <img
        class="course-img4"
        (click)="open(content, courses[10]?.id, '4')"
        [src]="courses[10]?.CardIconURL"
      />
      <img
        class="course-img5"
        (click)="open(content, courses[7]?.id, '5')"
        [src]="courses[7]?.CardIconURL"
      />
      <img
        class="course-img6"
        (click)="open(content, courses[13]?.id, '6')"
        [src]="courses[13]?.CardIconURL"
      />
      <img
        class="course-img7"
        (click)="open(content, courses[17]?.id, '6+')"
        [src]="courses[17]?.CardIconURL"
      />
      <img
        class="course-img8"
        (click)="open(content, courses[3]?.id, '6')"
        [src]="courses[3]?.CardIconURL"
      />
      <img
        class="course-img9"
        (click)="open(content, courses[5]?.id, '7')"
        [src]="courses[5]?.CardIconURL"
      />
      <img
        class="course-img10"
        (click)="open(content, courses[6]?.id, '8')"
        [src]="courses[6]?.CardIconURL"
      />
      <img
        class="course-img11"
        (click)="open(content, courses[14]?.id, '9')"
        [src]="courses[14]?.CardIconURL"
      />
      <img
        class="course-img12"
        (click)="open(content, courses[8]?.id, '7')"
        [src]="courses[8]?.CardIconURL"
      />
      <img
        class="course-img13"
        (click)="open(content, courses[2]?.id, '8')"
        [src]="courses[2]?.CardIconURL"
      />
      <img
        class="course-img14"
        (click)="open(content, courses[9]?.id, '6')"
        [src]="courses[9]?.CardIconURL"
      />
      <img
        class="course-img15"
        (click)="open(content, courses[11]?.id, '7')"
        [src]="courses[11]?.CardIconURL"
      />
      <img
        class="course-img16"
        (click)="open(content, courses[12]?.id, '8')"
        [src]="courses[12]?.CardIconURL"
      />
      <img
        class="course-img17"
        (click)="open(content, courses[15]?.id, '9')"
        [src]="courses[15]?.CardIconURL"
      />
    </div>
  </section>
  <section class="mt-5">
    <div>
      <h1 class="text-center main-color word-edit">
       {{'teatcher-watch-progress'|translate}} <br />
        {{'coll-level'|translate}}
      </h1>
      <h3 class="text-center mt-3 words-color">
        {{'teacher-text'|translate}}
      </h3>
      <div class="edit-picture">
        <div class="mt-3 d-flex justify-content-center me-4">
          <img
            class="edit-correct"
            src="assets_main/images/greencorrect.png"
            alt=""
          />
          <p class="edit-pharagraph">{{'no-exp'|translate}}</p>
        </div>
        <div class="mt-4 d-flex justify-content-center edit-word">
          <img
            class="edit-correct"
            src="assets_main/images/bluecorrect.png"
            alt=""
          />
          <p class="edit-pharagraph">
            {{'teach-ans'|translate}}<br />
            {{'diff-level'|translate}}
          </p>
        </div>
      </div>
      <div class="book d-flex justify-content-center mt-5">
        <img class="edit-width" src="assets_main/images/computerdesign.png" alt="" />
        <img class="edit-photo mt-5" src="assets_main/images/book.png" alt="" />
      </div>
    </div>
  </section>
  <section class="mt-5">
    <div>
      <h1 class="text-center main-color word-edit">
         {{'admin-see'|translate}}<br />
        {{'school-prog'|translate}}
      </h1>
    </div>
    <div class="d-flex justify-content-center edit-design">
      <div class="d-flex me-4">
        <img
          class="edit-correct res-design"
          src="assets_main/images/greencorrect.png"
          alt=""
        />
        <h3 class="edit-ph res-ph">{{'activity-last'|translate}}</h3>
      </div>
      <div class="d-flex me-1">
        <img class="edit-correct" src="assets_main/images/bluecorrect.png" alt="" />
        <h3 class="edit-ph">{{'CLASSROOM-RANKING'|translate}}</h3>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-1 edit-design">
      <div class="d-flex me-2">
        <img class="edit-correct" src="assets_main/images/bluecorrect.png" alt="" />
        <h3 class="edit-ph me-5">{{'top-stud'|translate}}</h3>
      </div>
      <div class="d-flex me-5">
        <img class="edit-correct" src="assets_main/images/greencorrect.png" alt="" />
        <h3 class="edit-ph">{{'RECENT-ACTIVITY'|translate}}</h3>
      </div>
    </div>
  </section>
  <section class="mt-5">
    <div>
      <h1 class="text-center words-color">
        + {{'STUDENT-MANAGEMENT'|translate}}, {{'CLASSROOM'|translate}} <br />
        {{'teach-management'|translate}}
      </h1>
    </div>
    <div class="d-flex justify-content-center">
      <img class="width" src="assets_main/images/computerrobo.png" alt="" />
    </div>
  </section>
</section>
<app-subscribe></app-subscribe>
<app-footer></app-footer>

<ng-template #content let-modal>
  <div class="modal-body">
    <button
      type="button"
      class="close edit-close"
      aria-label="Close"
      (click)="modal.dismiss('')"
    >
      <span class="edit-quit" aria-hidden="true">×</span>
    </button>
    <div class="row mx-0">
      <div class="col-lg-6 col-12 position">
        <div class="squire">
          <p class="edit-circle">{{ nums }}</p>
        </div>
        <p class="edit-phhhh" [innerHTML]="jounerData.Description">
         
        </p>
        <img class="edit-pic" [src]="jounerData.CardIconURL" alt="" />
      </div>
      <div class="col-lg-6 col-12 edit-text">
        <h3 class="color text-uppercase">
          {{'journey'|translate}} :<br />
          <span class="sec-color">
            {{ jounerData.name }}
          </span>
        </h3>
       <div class="edit-picture">
        <img
        class="edits-width"
        src="assets_main/images/computeradventure.png"
        alt=""
      />
       </div>
        <p class="sec-color mt-5">{{'MAIN-GOAL'|translate}}</p>
        <p class="edit-li">{{'identify-commands'|translate}}</p>
        <p class="sec-color">{{'STEAM'|translate}}</p>
        <p class="edit-li">{{'identify-animals'|translate}}</p>
        <p class="edit-li">{{'add-values'|translate}}</p>
        <p class="sec-color mt-1">{{'CODING'|translate}}</p>
        <p class="edit-li">{{'move-for'|translate}}</p>
        <p class="edit-li">{{'print-lett'|translate}}</p>
      </div>
    </div>
  </div>
  <!--  <div class="modal-footer"></div> -->
</ng-template>
